
import { Plugin, ButtonView, ContextualBalloon, Dialog, clickOutsideHandler, icons } from 'ckeditor5';
import FileManagerView from './FileManagerView';
import ArquivoConteudo from '@/Models/Domain/Servico/ArquivoConteudo';
export default class FileManagerUI extends Plugin {
    /// @ts-ignore
    _formView:FileManagerView;
    /// @ts-ignore
    static get requires() {
		return [ ContextualBalloon, Dialog ];
	}

    _createFormView({onChange}:{
		onChange:(arquivo:ArquivoConteudo) => void
	}) {
		const editor = this.editor;
		const formView = new FileManagerView({
			locale : editor.locale,
			onChange(arquivo) {
				console.log("OnChange: ", arquivo);
				onChange(arquivo);
			},
		});

		return formView;
	}
	init() {
		console.log( 'FileManagerUI#init() got called' );

        const editor = this.editor;

        const dialog = this.editor.plugins.get(Dialog);
        this._formView = this._createFormView({
			onChange(arquivo) {
				dialog.hide();
				editor.execute('insertImage', { source: process.env.NODE_ENV === "development" 
					? `https://localhost:7123/api/domain/servico/ArquivoConteudo?caminho=${arquivo.path}` 
					: `${window.location.origin}/api/api/domain/servico/ArquivoConteudo?caminho=${arquivo.path}` 
				} );
			},
		});

		editor.ui.componentFactory.add('FileManager', () => {
			const button = new ButtonView();

			button.icon = "";
			button.label = 'Arquivos';
			button.tooltip = true;
			button.withText = false;
			button.icon = icons.browseFiles;

			this.listenTo(button, 'execute', () => {
				console.log("FileManagerUI#Arquivos#listenTo")
                
                button.isOn = true;

                dialog.show({
                    id : 'gerenciador_arquivos',
					title: 'Gerenciador de arquivos',
					position : "screen-center",
					content: this._formView,
                    isModal: true,
					actionButtons: [
						{
							label: 'OK',
							class: 'ck-button-action',
							withText: true,
							onExecute: () => dialog.hide()
						}
					],
					onHide() { 
                        button.isOn = false; 
                    }
				} );
			} );

			return button;
		} );
	}
}